import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material';
import { ToastrServiceLocal } from 'app/services/toast/toastr.service';
import { LoginPostulanteFacadeService } from '../login-postulante-facade.service';
import { CambioExitosoModalComponent } from './cambio-exitoso-modal.component';

@Component({
  selector: 'app-cambio-credencial-postulante',
  templateUrl: './cambio-credencial-postulante.component.html',
  styleUrls: ['./cambio-credencial-postulante.component.css']
})
export class CambioCredencialPostulanteComponent implements OnInit, OnDestroy {

  changePasswordForm: FormGroup;
  hide1: boolean = true;
  hide2: boolean = true;
  hide3: boolean = true;
  contraseñaNoIgual: boolean;

  constructor(
    private fb: FormBuilder,
    private _router: Router,
    private _toast: ToastrServiceLocal,
    public loginFacade: LoginPostulanteFacadeService,
    public modal: MatDialog
  ) {
    this.changePasswordForm = this.fb.group({
      anteriorPassword: ['', Validators.required],
      newPassword: ['', [Validators.required, Validators.minLength(8)]],
      repeatPassword: ['', Validators.required]
    });
  }

  ngOnInit(): void {
    document.documentElement.style.backgroundColor = '#071019';
  }

  ngOnDestroy(): void {
    document.documentElement.style.backgroundColor = '';
  }

  toggleHide1() {
    this.hide1 = !this.hide1;
  }

  toggleHide2() {
    this.hide2 = !this.hide2;
  }

  toggleHide3() {
    this.hide3 = !this.hide3;
  }

  // Verifica si las contraseñas coinciden
  get passwordsDoNotMatch(): boolean {
    const newPassword = this.changePasswordForm.get('newPassword')?.value;
    const repeatPassword = this.changePasswordForm.get('repeatPassword')?.value;

    this.contraseñaNoIgual = newPassword && repeatPassword && newPassword !== repeatPassword;
    return this.contraseñaNoIgual;
  }

  onSubmit() {
    if (this.contraseñaNoIgual === false) {
      const params = {
        anteriorPassword: this.changePasswordForm.value.anteriorPassword,
        newPassword: this.changePasswordForm.value.repeatPassword,
      };

      this.loginFacade.cambioCredencialPostulante(params).subscribe((result) => {
        const mensajes: any[] = result?.data?.Table0 || [];
        const exito = mensajes.some((asignatura) => asignatura.codigo === 0);
        if (exito) {
          this.finalizarCambioExitoso();
        }
      });
    } else {
      this._toast.mensajeError('Tus nuevas credenciales no coinciden.', '');
    }
  }

  cerrarSesion() {
    localStorage.clear();
    sessionStorage.clear();
    this._router.navigateByUrl('/postulante/login');
  }

  private finalizarCambioExitoso() {
    localStorage.clear();
    sessionStorage.clear();
    this._router.navigateByUrl('/postulante/login').then(() => {
      this.modal.open(CambioExitosoModalComponent, {
        width: window.innerWidth < 760 ? '90%' : '360px',
        disableClose: true,
        panelClass: 'cambio-exitoso-dialog',
      });
    });
  }
}
